import { isEqual } from 'lodash'
import * as React from 'react'

interface TriggerState {
  show: boolean
}

interface AbstractTrigger<P, S extends TriggerState = TriggerState>
  extends React.Component<P, S> {
  timerLength?: number
  closeTrigger?(): void
  updateShow?(props: P, mount?: boolean): void
}
class AbstractTrigger<P, S> extends React.Component<P, S> {
  private timer: any

  public componentDidMount() {
    if (this.updateShow) {
      this.updateShow(this.props, true)
    }
  }

  public componentDidUpdate(props: P, state: TriggerState) {
    if (
      this.updateShow &&
      (!isEqual(this.props, props) || !isEqual(this.state, state))
    ) {
      this.updateShow(this.props)
    }
  }

  public componentWillUnmount() {
    this.clearTimer()
  }

  public onClose = () => {
    this.setState({ show: false })
    if (this.closeTrigger) {
      this.closeTrigger()
    }
  }

  public startTimer = (show?: boolean, callback?: () => void) => {
    if (this.timerLength !== undefined) {
      if (this.timer === undefined) {
        this.timer = setTimeout(() => {
          this.setState({ show: show || false }, callback)
          this.timer = undefined
        }, this.timerLength)
      }
    }
  }

  public clearTimer = () => {
    clearTimeout(this.timer)
    this.timer = undefined
  }
}

export default AbstractTrigger
